var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-info" }, [
    _c("div", { staticClass: "form-row spacing" }, [
      _c("div", { staticClass: "form-row", staticStyle: { height: "88px" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-1-5x" },
          [
            _c(
              "el-select",
              {
                staticClass: "fl",
                attrs: { placeholder: "请选择", clearable: true },
                model: {
                  value: _vm.userId,
                  callback: function($$v) {
                    _vm.userId = $$v
                  },
                  expression: "userId"
                }
              },
              _vm._l(_vm.retailerStaffList, function(item) {
                return _c("el-option", {
                  key: item.name,
                  attrs: { label: item.name, value: item.userId }
                })
              })
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("指定审核人：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-629b7252", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-629b7252","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/AppointAuditor.vue
// module id = 2887
// module chunks = 0